import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoCountdownTimer',
  props: {
    videoDuration: { default: 0 },
    currentTime: { default: 0 },
    size: { default: 32 }
  },
  setup(__props: any) {

const props = __props as { videoDuration: number, currentTime: number, size: number };


const strokeWidth = 2;
const center = computed(() => props.size / 2);
const radius = computed(() => center.value - strokeWidth);
const circumference = computed(() => 2 * Math.PI * radius.value);

const progressTime = computed(() => Math.min(props.currentTime, props.videoDuration));

const dashOffset = computed(() => {
	return ((props.videoDuration - progressTime.value) / props.videoDuration) * circumference.value;
});

const remaining = computed(() => Math.ceil(Math.max(0, props.videoDuration - progressTime.value)));

return { __sfc: true,props, strokeWidth, center, radius, circumference, progressTime, dashOffset, remaining }
}

})